/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBadgeIndicator } from "abreact/misc/AbBadgeIndicator";
import { AbPopupButton } from "abreact/misc/AbPopupButton";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { AbCheckbox } from "absdk/commons/ui/input/AbCheckbox";
import { AbToggleButton } from "absdk/commons/ui/misc/AbToggleButton";
import { AbIcon } from "absdk/commons/ui/misc/AbIcon";
import { StringUtils } from "abweb/utils/StringUtils";
import Immutable from "immutable";
import * as React from "react";
const DEFAULT_ICON = "absdk:ei-component-check-box";
export function ExecutionFlags(props) {
  const inlineLimit = props.inlineLimit ?? 2;
  const executionFlags = props.domain.getExpExecutionFlags().filter(flag => props.eligibleFlags.has(flag.id) && (flag.valueTypeIDs === undefined || !props.valueTypeIDs.intersect(Immutable.List(flag.valueTypeIDs)).isEmpty()));
  const selected = new Set(props.selectedFlags);
  const flagsContent = /*#__PURE__*/React.createElement(React.Fragment, null, executionFlags.length <= inlineLimit && executionFlags.map((flag, index) => /*#__PURE__*/React.createElement(AbToggleButton, {
    key: flag.id,
    className: "ab-no-border-button",
    dataTestId: `ab-gee-execution-flags-button-${index}`,
    disabled: props.disabled,
    icon: flag.icon ?? DEFAULT_ICON,
    tooltip: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, flag.label), flag.description && /*#__PURE__*/React.createElement("div", null, flag.description)),
    value: selected.has(flag.id),
    onChange: value => changeSelection(flag.id, value, props)
  })), executionFlags.length > inlineLimit && /*#__PURE__*/React.createElement(AbBadgeIndicator, {
    value: selected.size
  }, /*#__PURE__*/React.createElement(AbPopupButton, {
    className: "ab-no-border-button",
    dataTestId: "ab-gee-execution-flags-popup-button",
    icon: "absdk:settings",
    popupProps: {
      className: "ab-gee-execution-flags",
      dataTestId: "ab-gee-execution-flags-popup"
    },
    popupContents: /*#__PURE__*/React.createElement("div", {
      className: "flag-popup"
    }, executionFlags.map((flag, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: flag.id
    }, /*#__PURE__*/React.createElement(AbCheckbox, {
      tooltip: flag.description,
      dataTestId: `ab-gee-execution-flags-checkbox-${index}`,
      value: selected.has(flag.id),
      onChange: value => changeSelection(flag.id, value, props)
    }), /*#__PURE__*/React.createElement(AbIcon, {
      image: flag.icon ?? DEFAULT_ICON,
      tooltip: flag.description
    }), /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: flag.description
    }, /*#__PURE__*/React.createElement("span", null, flag.label))))),
    disabled: props.disabled
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: StringUtils.cssClassStr("ab-gee-execution-flags", props.className)
  }, flagsContent);
}
function changeSelection(flagId, selected, props) {
  const updated = new Set(props.selectedFlags);
  if (selected) {
    updated.add(flagId);
  } else {
    updated.delete(flagId);
  }
  props.onChange?.(updated);
}
//# sourceMappingURL=ExecutionFlags.js.map
